// src/pages/Plans.tsx

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SubscriptionPlans from '../components/subscription/SubscriptionPlans';

const Plans: React.FC = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/profile');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-md md:max-w-2xl mx-auto px-4 py-4 flex items-center">
          <Link
            to="/profile"
            className="mr-3 p-2 -ml-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <ArrowLeft size={20} className="text-gray-600" />
          </Link>
          <h1 className="text-xl font-bold text-gray-900">Choose Your Plan</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-md md:max-w-2xl mx-auto">
        <SubscriptionPlans
          onClose={handleClose}
          className="p-4 md:p-6"
        />
      </div>
    </div>
  );
};

export default Plans;